const SvgOperations1 = (props) => (
  <>
    <defs />
    <path d="M280.49 287.46H95.78" stroke="#042068" strokeWidth="3px" fill="none" strokeMiterlimit={10} />
    <path d="M287.58 280.32V102.15" strokeLinejoin="round" stroke="#042068" fill="none" strokeWidth="3px" />
    <path
      transform="rotate(-180 288 96)"
      d="M208 16h160v160H208z"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <path
      transform="rotate(-180 96 96)"
      d="M16 16h160v160H16z"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <path
      transform="rotate(-180 288 288)"
      d="M208 208h160v160H208z"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <path
      transform="rotate(-180 96 288)"
      d="M16 208h160v160H16z"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <circle cx={288.12} cy={288} r={8} stroke="#021d6c" strokeWidth="3px" fill="none" strokeMiterlimit={10} />
    <path d="M95.78 95.6h184.71" stroke="#042068" strokeWidth="3px" fill="none" strokeMiterlimit={10} />
    <circle cx={96} cy={96} r={8} fill="#1e62f3" strokeWidth={0} />
    <circle cx={96} cy={96} r={24} stroke="#021d6c" strokeMiterlimit={10} fill="none" />
    <path
      d="M111.49 303.21 95.82 287.4l16.22-14.16"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <circle cx={288} cy={96} r={8} stroke="#021d6c" strokeWidth="3px" fill="none" strokeMiterlimit={10} />
  </>
);

export default SvgOperations1;
